import classNames from 'classnames';
import { FC, TextareaHTMLAttributes, forwardRef } from 'react';
import { AiOutlineQuestionCircle } from 'react-icons/ai';
import Tooltip from './Tooltip';

interface CustomTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string;
  label: string;
  errMsg?: string;
  tooltipText?: string;
  labelAbove?: boolean;
  textWhite?: boolean;
}

const FormControlTextArea: FC<CustomTextareaProps> = forwardRef<
HTMLTextAreaElement,
CustomTextareaProps
>(({
  id, label, errMsg, tooltipText, labelAbove, textWhite, ...rest
}, ref) => {
  const commonClasses = 'text-text-primary p-3 border focus:outline-none focus:ring-1 border-transparent focus:ring-primary-500/20 hover:border-border-secondary transition-all duration-200';

  const textareaClasses = classNames(
    commonClasses,
    'w-full', // Make the textarea wider
    {
      'border-red-500': errMsg,
      'text-white': textWhite,
      'bg-surface-base': !rest.disabled,
      'bg-surface-secondary': rest.disabled,
    },
    'bg-surface-base',
    'border-b-2',
    'rounded-3xl',
    'dark:border-gradient-brand',
    'button-shadow',
    'resize-none',
  );

  return (
    <div className="form-control flex flex-col mb-2 w-full">
      {labelAbove && (
        <div className="flex items-center w-full">
          <label htmlFor={id} className="text-left font-sm font-medium">
            {label}
          </label>
          {tooltipText && (
            <Tooltip content={tooltipText}>
              <AiOutlineQuestionCircle className="ml-1" />
            </Tooltip>
          )}
        </div>
      )}
      <div className="flex items-center">
        <textarea
          ref={ref}
          id={id}
          placeholder={label}
          className={textareaClasses}
          {...rest}
        />
      </div>
      <span className="text-red-500 white-text-shadow">{errMsg}</span>
    </div>
  );
});

export default FormControlTextArea;
